import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import accountCheck from "@iconify/icons-mdi/account-check";
import { Icon } from "@iconify/react";

interface OcExaminersListProps {
  examinersData: string[]; // Replace 'string[]' with the appropriate type if needed
  loading: boolean;
}

export const OcExaminersList: React.FC<OcExaminersListProps> = ({
  examinersData,
  loading,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (examinersData?.length === 0 && !loading) {
    return (
      <Box style={{ color: theme.palette.primary.main, padding: "16px 0px" }}>
        {t("OC_MISSING_EXAMINERS")}
      </Box>
    );
  }

  return (
    <>
      {examinersData?.map((item, index) => {
        return (
          <Box
            key={`oc-examiners-list-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon icon={accountCheck} height="24px" />
            <Box width="10px" />
            <Box paddingBottom="4px">{item}</Box>
          </Box>
        );
      })}
    </>
  );
};

export default OcExaminersList;
